import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch, faAngleUp, faClone, faStar, faUpRightFromSquare} from '@fortawesome/free-solid-svg-icons'
import { faFilePdf, faFileExcel } from '@fortawesome/free-regular-svg-icons'
import Ticker1 from "../components/Ticker1";
import { formatLargeNumber, formatCurrency } from '../utils/currencyUtils';
import { useNavigate, useLocation, Link } from 'react-router-dom'
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { toast } from 'react-hot-toast';

function Idetails() {
  const { state } = useLocation();
  const [loading, setLoading] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    const hasType = state?.symbol;
    if (!hasType) {
      navigate('/retirement', { replace: true });
    } else {
      setLoading(false);
    }
  }, [state, navigate]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [crypto, setCrypto] = useState([]);
  useEffect(() => {
    fetch(`/coin_list.txt`)
    .then((res) => res.json())
    .then((data) => {
    var coinList = data.data;
    const updatedData = coinList.map((coin, index) => ({
        id: index + 1,
        logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
        name: coin.name,
        type: 'crypto',
        symbol: coin.symbol,
        price: Number(coin.quote.USD.price.toFixed(2)),
        percentage: Number(coin.quote.USD.percent_change_24h.toFixed(2)),
        amount: 0,
    }));
    setCrypto(updatedData);
    })
    .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  const [mutualfunds, setMutualfunds] = useState([]);
  const [etfs, setEtfs] = useState([]);
  const [allFunds, setAllFunds] = useState([]);
  const [iDetails, setIDetails] = useState([]);
  useEffect(() => {
      fetch(`/uploads/investment/etfs.txt`)
      .then((res) => res.json())
      .then((data) => {
      var investment = data;
        setEtfs(investment);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
      fetch(`/uploads/investment/mutualfunds.txt`)
      .then((res) => res.json())
      .then((data) => {
      var investment = data;
        setMutualfunds(investment);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    if (!etfs.length && !mutualfunds.length) return;
    const merged = [...etfs, ...mutualfunds];
    for (let i = merged.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [merged[i], merged[j]] = [merged[j], merged[i]];
    }
    setAllFunds(merged);
  }, [etfs, mutualfunds]);
  useEffect(() => {
    if (!state && !allFunds.length) return;
    const details = allFunds.find(asset => asset.symbol === state?.symbol);
    if (details) {
      const rating = Math.floor(Math.random() * 3) + 3;
      const updatedDetails = { ...details, rating };
      setIDetails(updatedDetails);
    }
  }, [allFunds, state]);

  //DOWNLOAD PDF
  const downloadPDF = () => {
    const input = document.querySelector("main.mb-5"); 
    if (!input) {
      alert("Section not found!");
      return;
    }
    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 210;
      const pageHeight = 297;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;
      let position = 0;
      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      pdf.save("fund-details.pdf");
    });
  };
  
  //SHARE LINK
  const sharePage = async () => {
    const url = window.location.href;
    if (navigator.share) {
      await navigator.share({
        title: document.title,
        text: "Check this out!",
        url: url,
      });
    } else {
      await navigator.clipboard.writeText(url);
      toast.success('Copied to Clipboard!')
    }
  };
  //DOWNLOAD EXCEL DATA
  const downloadExcel = () => {
    if (!iDetails || typeof iDetails !== "object") return;
    const flattenObject = (obj, prefix = "") => {
      let res = {};
      for (let key in obj) {
        if (typeof obj[key] === "object" && obj[key] !== null && !Array.isArray(obj[key])) {
          const flat = flattenObject(obj[key], prefix + key + ".");
          res = { ...res, ...flat };
        } else {
          res[prefix + key] = Array.isArray(obj[key])
            ? JSON.stringify(obj[key])
            : obj[key];
        }
      }
      return res;
    };
    const flatData = flattenObject(iDetails);
    const worksheet = XLSX.utils.json_to_sheet([flatData]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Details");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "details.xlsx");
  };
  
  if (loading || !iDetails || typeof iDetails !== 'object' || Object.keys(iDetails).length === 0) {
    return <div style={{ textAlign: "center", marginTop: "20%" }}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#ff6b35', opacity: '0.5'}} spin /></div>;
  }

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Retirement Investment" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Retirement Investment" icon={<FontAwesomeIcon icon={faClone} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main className="mb-5" style={{backgroundColor:'#07080a'}}>
            <div className="mt-2">
              <Ticker1 crypto={crypto} pauseOnHover />
            </div>
            <div className="container mt-4">
                <div className="row">
                    <div className="col-12">
                        <div className="d-lg-flex align-items-center justify-content-between flew-wrap">
                            <p className="mb-0 fw-bold">{iDetails.quoteType}</p>
                            <div className="d-flex align-items-center flex-wrap mt-3 mt-lg-0" style={{gap:'10px'}}>
                                <div className="mb-0 noLink" onClick={downloadPDF} style={{fontSize:'14px',cursor:'pointer'}}><FontAwesomeIcon icon={faFilePdf} className="text-danger" style={{fontSize: '14px'}} /> Fact Sheet</div>
                                <div className="mb-0 noLink" onClick={downloadPDF} style={{fontSize:'14px',cursor:'pointer'}}><FontAwesomeIcon icon={faFilePdf} className="text-danger" style={{fontSize: '14px'}} /> Prospectus</div>
                                <div className="mb-0 noLink" onClick={sharePage} style={{fontSize:'14px',cursor:'pointer'}}><FontAwesomeIcon icon={faUpRightFromSquare} className="text-info" style={{fontSize: '14px'}} /> Financial and Legal Documents</div>
                                <div className="mb-0 noLink" onClick={downloadExcel} style={{fontSize:'14px',cursor:'pointer'}}><FontAwesomeIcon icon={faFileExcel} className="text-success" style={{fontSize: '14px'}} /> Data Download</div>
                            </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-6">
                            <div className="d-flex align-items-center mt-4">
                                <div className="d-flex align-items-center justify-content-center bg-info px-3" style={{height:'76px'}}>
                                    <h4 className="mb-0" style={{fontWeight:'900'}}>{iDetails.symbol}</h4>
                                </div>
                                <h1 className="mb-0 ms-3" style={{fontWeight:'900', maxWidth:'630px'}}>{iDetails.longName}</h1>
                            </div>
                            <div className="d-flex flex-wrap mt-5" style={{gap:'30px'}}>
                                <div>
                                    <p className="mb-0" style={{fontSize:'12px'}}>NAV as of {new Date(iDetails.regularMarketTime * 1000).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric'})}</p>
                                    <p className="mb-0 fs-2 text-info">${Number(iDetails.regularMarketPrice).toFixed(2)}</p>
                                    <p className="mb-0" style={{fontSize:'12px'}}>52 WK: {iDetails.fiftyTwoWeekRange}</p>
                                </div>
                                <div>
                                    <p className="mb-0" style={{fontSize:'12px'}}>1 Day NAV Change as of {new Date(iDetails.regularMarketTime * 1000).toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric'})}</p>
                                    <p className="mb-0 fs-2"><FontAwesomeIcon icon={faAngleUp} className="text-success fs-3 align-middle" /> {Number(iDetails.regularMarketChange).toFixed(2)} ({Number(iDetails.regularMarketChangePercent).toFixed(2)}%)</p>
                                </div>
                                <div>
                                    <p className="mb-0" style={{fontSize:'12px'}}>NAV Total Return as of {new Date().toLocaleDateString('en-US', {month: 'short',day: '2-digit',year: 'numeric'})}</p>
                                    <p className="mb-0 fs-2">YTD: <FontAwesomeIcon icon={faAngleUp} className="text-success fs-3 align-middle" /> {Number(iDetails.ytdReturn).toFixed(2)}%</p>
                                </div>
                                <div>
                                    <p className="mb-2" style={{fontSize:'12px'}}>Morningstar Rating</p>
                                    <div className="d-flex align-items-center" style={{ gap: "5px" }}>
                                      {[...Array(5)].map((_, i) => (
                                        <FontAwesomeIcon
                                          key={i}
                                          icon={faStar}
                                          className={i < iDetails.rating ? "text-warning fs-5" : "text-secondary fs-5"}
                                        />
                                      ))}
                                    </div>
                                </div>
                            </div>
                            <div className="mt-3 ">
                                <p className="mb-0" style={{fontSize:'12px'}}>Fees as stated in the prospectus</p>
                                <p className="mb-0 fs-2">Expense Ratio: {Number(iDetails.netExpenseRatio).toFixed(2)}%</p>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="d-flex justify-content-end">
                              <img src="uploads/chart-etf-and-mutual-fund-comparison.png" alt="logo" className="img-fluid mt-4" style={{maxWidth:'550px'}}/>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-black w-100 mt-5">
              <div className="container d-flex align-items-center flex-wrap justify-content-between" style={{gap:'20px'}}>
                  <a href="#overview" className="px-4 py-2 fs-5 noLink fadeHover">Overview</a>
                  <a href="#portfolio" className="px-4 py-2 fs-5 noLink fadeHover">Performance & Distributions</a>
                  <a href="#keyfacts" className="px-4 py-2 fs-5 noLink fadeHover">Key Facts</a>
                  <a href="#fees" className="px-4 py-2 fs-5 noLink fadeHover">Fees</a>
                  <a href="#" className="px-4 py-2 fs-5 noLink fadeHover">Holdings</a>
                  <a href="#" className="px-4 py-2 fs-5 noLink fadeHover">Literature</a>
              </div>
            </div>
            <div className="container">
              <div id="overview">
                <div className="row">
                  <div className="col-lg-6 g-4">
                    <p className="mb-2 fs-4" style={{fontWeight:'900'}}>Why {iDetails.symbol}?</p>
                    <ol>
                      <li className="mb-3">Exposure to developed market equities outside the U.S.</li>
                      <li className="mb-3">Seeks to track the performance of the {iDetails.longName}</li>
                      <li className="mb-3">Use to diversify your portfolio with international equity exposure</li>
                    </ol>
                  </div>
                  <div className="col-lg-6 g-4">
                    <p className="mb-2 fs-4" style={{fontWeight:'900'}}>INVESTMENT OBJECTIVE</p>
                    <p className="mb-0">The {iDetails.longName} aims to track the performance of a benchmark index that measures the investment return of stocks in developed markets outside the United States.</p>
                  </div>
                </div>
              </div>
              <div id="keyfacts">
                <p className="mb-4 mt-5 fs-2 text-center" style={{fontWeight:'900'}}>Key Facts</p>
                <div className="row">
                  <div className="col-lg-6 g-4">
                    <div className="d-flex justify-content-between">
                      <div>
                        <p className="mb-0" style={{fontSize:'14px'}}>Net Assets of Fund</p>
                        <p className="mb-0" style={{fontSize:'14px'}}>as of {new Date(
                          iDetails.regularMarketTime * 1000
                        ).toLocaleDateString('en-US', {
                          month: 'short',
                          day: '2-digit',
                          year: 'numeric',
                        })}</p>
                      </div>
                      <p className="mb-0" style={{fontSize:'14px'}}>${formatCurrency(iDetails.netAssets)}</p>
                    </div>
                    <hr className="my-2"/>
                    <div className="d-flex justify-content-between">
                      <p className="mb-0" style={{fontSize:'14px'}}>Exchange</p>
                      <p className="mb-0" style={{fontSize:'14px'}}>{iDetails.fullExchangeName}</p>
                    </div>
                    <hr className="my-2"/>
                    <div className="d-flex justify-content-between">
                      <p className="mb-0" style={{fontSize:'14px'}}>Symbol</p>
                      <div>
                        <p className="mb-0" style={{fontSize:'14px'}}>{iDetails.symbol}</p>
                      </div>
                    </div>
                    <hr className="my-2"/>
                    <div className="d-flex justify-content-between">
                      <div>
                        <p className="mb-0" style={{fontSize:'14px'}}>Currency</p>
                      </div>
                      <p className="mb-0" style={{fontSize:'14px'}}>{iDetails.currency}</p>
                    </div>
                    <hr className="my-2"/>
                    <div className="d-flex justify-content-between">
                      <div>
                        <p className="mb-0" style={{fontSize:'14px'}}>52-Week Range</p>
                      </div>
                      <p className="mb-0" style={{fontSize:'14px'}}>{iDetails.fiftyTwoWeekRange}</p>
                    </div>
                    <hr className="my-2"/>
                    <div className="d-flex justify-content-between">
                      <div>
                        <p className="mb-0" style={{fontSize:'14px'}}>Dividend Yield (TTM)</p>
                      </div>
                      <p className="mb-0" style={{fontSize:'14px'}}>{iDetails.dividendYield}%</p>
                    </div>
                    <hr className="my-2"/>
                    <div className="d-flex justify-content-between">
                      <div>
                        <p className="mb-0" style={{fontSize:'14px'}}>Market Price</p>
                      </div>
                      <p className="mb-0" style={{fontSize:'14px'}}>${Number(iDetails.regularMarketPrice).toFixed(2)}</p>
                    </div>
                    <hr className="my-2"/>
                  </div>
                  <div className="col-lg-6 g-4">
                    <div className="d-flex justify-content-between">
                      <p className="mb-0" style={{fontSize:'14px'}}>Fund Launch Date</p>
                      <p className="mb-0" style={{fontSize:'14px'}}>{new Date(
                        iDetails.firstTradeDateMilliseconds
                      ).toLocaleDateString('en-US', {
                        month: 'short',
                        day: '2-digit',
                        year: 'numeric',
                      })}</p>
                    </div>
                    <hr className="my-2"/>
                    <div className="d-flex justify-content-between">
                      <p className="mb-0" style={{fontSize:'14px'}}>Market</p>
                      <p className="mb-0" style={{fontSize:'14px'}}>{iDetails?.market}</p>
                    </div>
                    <hr className="my-2"/>
                    <div className="d-flex justify-content-between">
                      <p className="mb-0" style={{fontSize:'14px'}}>Average Daily Volume (3M)</p>
                      <p className="mb-0" style={{fontSize:'14px'}}>{formatCurrency(iDetails.averageDailyVolume3Month)}</p>
                    </div>
                    <hr className="my-2"/>
                    <div className="d-flex justify-content-between">
                      <p className="mb-0" style={{fontSize:'14px'}}>P/E Ratio (TTM)</p>
                      <p className="mb-0" style={{fontSize:'14px'}}>{Number(iDetails.peTTM).toFixed(2)}</p>
                    </div>
                    <hr className="my-2"/>
                    <div className="d-flex justify-content-between">
                      <p className="mb-0" style={{fontSize:'14px'}}>Yield (TTM)</p>
                      <p className="mb-0" style={{fontSize:'14px'}}>{iDetails.yieldTTM}%</p>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div id="portfolio">
                <p className="mb-4 mt-5 fs-2 text-center" style={{fontWeight:'900'}}>Portfolio Characteristics</p>
                <div className="row">
                  <div className="col-lg-6 g-4">
                    <div className="d-flex justify-content-between">
                      <div>
                        <p className="mb-0" style={{fontSize:'14px'}}>Number of Holdings</p>
                        <p className="mb-0" style={{fontSize:'14px'}}>as of Sep 30, 2025</p>
                      </div>
                      <p className="mb-0" style={{fontSize:'14px'}}>41</p>
                    </div>
                    <hr className="my-2"/>
                    <div className="d-flex justify-content-between">
                      <div>
                        <p className="mb-0" style={{fontSize:'14px'}}>30 Day SEC Yield</p>
                        <p className="mb-0" style={{fontSize:'14px'}}>as of Aug 29, 2025</p>
                      </div>
                      <p className="mb-0" style={{fontSize:'14px'}}>0.64%</p>
                    </div>
                    <hr className="my-2"/>
                    <div className="d-flex justify-content-between">
                      <div>
                        <p className="mb-0" style={{fontSize:'14px'}}>Standard Deviation (3y)</p>
                        <p className="mb-0" style={{fontSize:'14px'}}>as of Jul 31, 2025</p>
                      </div>
                      <p className="mb-0" style={{fontSize:'14px'}}>30.90%</p>
                    </div>
                    <hr className="my-2"/>
                    <div className="d-flex justify-content-between">
                      <div>
                        <p className="mb-0" style={{fontSize:'14px'}}>P/B Ratio</p>
                        <p className="mb-0" style={{fontSize:'14px'}}>as of Sep 30, 2025</p>
                      </div>
                      <p className="mb-0" style={{fontSize:'14px'}}>3.34</p>
                    </div>
                    <hr className="my-2"/>
                  </div>
                  <div className="col-lg-6 g-4">
                    <div className="d-flex justify-content-between">
                      <div>
                        <p className="mb-0" style={{fontSize:'14px'}}>Equity Beta (3y)</p>
                        <p className="mb-0" style={{fontSize:'14px'}}>as of Jul 31, 2025</p>
                      </div>
                      <p className="mb-0" style={{fontSize:'14px'}}>0.47</p>
                    </div>
                    <hr className="my-2"/>
                    <div className="d-flex justify-content-between">
                      <div>
                        <p className="mb-0" style={{fontSize:'14px'}}>12m Trailing Yield</p>
                        <p className="mb-0" style={{fontSize:'14px'}}>as of Aug 29, 2025</p>
                      </div>
                      <p className="mb-0" style={{fontSize:'14px'}}>0.85%</p>
                    </div>
                    <hr className="my-2"/>
                    <div className="d-flex justify-content-between">
                      <div>
                        <p className="mb-0" style={{fontSize:'14px'}}>P/E Ratio</p>
                        <p className="mb-0" style={{fontSize:'14px'}}>as of Sep 30, 2025</p>
                      </div>
                      <p className="mb-0" style={{fontSize:'14px'}}>29.92</p>
                    </div>
                    <hr className="my-2"/>
                  </div>
                </div>
              </div> */}
              <div id="fees">
                <p className="mb-0 mt-5 fs-2 text-center" style={{fontWeight:'900'}}>Fees</p>
                <p className="mb-4 text-center" style={{fontSize:'14px'}}>as of current prospectus</p>
                <div className="row">
                  <div className="col-lg-6 offset-lg-3">
                    <div className="d-flex justify-content-between">
                      <p className="mb-0" style={{fontSize:'14px'}}>Expense Ratio</p>
                      <p className="mb-0" style={{fontSize:'14px'}}>{iDetails.netExpenseRatio}%</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Idetails